import api from './api';


// demoApi.js
export const getDemos = async (
  page = 1,
  limit = 10,
  employee_id,
  hostBy,
  search,
  status,
  startDate,
  endDate
) => {
  const token = localStorage.getItem("token");
  const params = { page, limit };

  if (search) params.search = search;
  if (status) params.status = status;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  if (employee_id && hostBy) {
    params.employee_id = employee_id;
    params.hostBy = hostBy;
  }

  const response = await api.get("/demos", {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data.data;
};




export const createBulkDemos = async (payload) => {
  const response = await api.post('/demos/bulk', payload);
  return response.data.data;
};

export const updateDemo = async ({ id, data }) => {
  const response = await api.put(`/demos/${id}`, data);
  return response.data.data;
};

export const sendMeetingInvite = async (payload) => { // payload = { demoIds, meetingLink }
  const response = await api.post('/demos/send-invite', payload);
  return response.data;
};

// api call
export const deleteDemo = async (id) => {
  const response = await api.delete(`/demos/${id}`);
  return response.data.data;
};
